const languages = {
  EN: 'English',
  FR: 'French',
}

export default languages
